import { useMutation } from '@tanstack/react-query';
import { operationApis } from '../../../../../../../shared/apis/operation/apis';

export default function usePostPopup() {
  const { mutate: postPopup } = useMutation(operationApis.postPopup);

  return { postPopup };
}
